<template>
  <div class="agb">
    <div class="hero is-info">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-2 is-size-3-mobile">Wilde Pracht</h1>
          <p class="subtitle is-4 is-size-5-mobile">
            Allgemeine Gesch&auml;ftsbedingungen
          </p>
        </div>
      </div>
    </div>
    <div class="section is-medium">
      <div class="container is-size-6 is-size-7-mobile">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <Agbtext />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Agbtext from "@/components/legal/Agbtext.vue";

export default {
  name: "AGB",
  components: {
    Agbtext
  },
  metaInfo: {
    title: "AGB | Wilde Pracht",
    meta: [
      {
        name: "description",
        content:
          "Du willst die allgemeinen Geschäftsbedingungen der Wilden Pracht wissen? Dann findest du hier die Antwort."
      },
      { itemprop: "name", content: "AGB | Wilde Prach" },
      { property: "og:title", content: "AGB | Wilde Prach" },
      {
        itemprop: "description",
        content:
          "Du willst die allgemeinen Geschäftsbedingungen der Wilden Pracht wissen? Dann findest du hier die Antwort."
      },
      {
        property: "og:description",
        content:
          "Du willst die allgemeinen Geschäftsbedingungen der Wilden Pracht wissen? Dann findest du hier die Antwort."
      },
      {
        name: "robots",
        content: "noindex"
      }
    ]
  }
};
</script>
